<template>
  <div class="cdo-page">
    <!-- 面包屑导航 -->
    <nav class="breadcrumb-nav">
      <router-link to="/">首页</router-link>
      <span class="separator">/</span>
      <router-link to="/training">培训中心</router-link>
      <span class="separator">/</span>
      <span class="current">AI 大语言模型 应用实战培训实践课程</span>
    </nav>

    <!-- ===== 01. Hero 区 ===== -->
    <section class="section" style="padding-top: 20px;">
      <div class="hero-gradient" style="border-radius: 24px; padding: 60px 48px;">
        <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 48px; align-items: center;">
          <!-- 左侧内容 -->
          <div>
            <div style="display: flex; align-items: center; gap: 12px; margin-bottom: 24px;">
              <span class="cdo-badge secondary">北京古杉数据 · 开卷有益</span>
            </div>
            <h1 class="cdo-h1" style="color: white;">AI大语言模型应用实战培训实践课程中高级内训课程</h1>
            <p style="color: rgba(255,255,255,0.85); font-size: 18px; max-width: 500px;">从理论到实战，掌握下一代AI核心技能</p>
            <div class="cdo-keyword-cloud" style="margin: 20px 0 28px;">
              <h2 class="cdo-keyword-tag" style="background: rgba(255,255,255,0.15); color: white; border-color: rgba(255,255,255,0.3);">电标院联合认证</h2>
              <h2 class="cdo-keyword-tag" style="background: rgba(255,255,255,0.15); color: white; border-color: rgba(255,255,255,0.3);">实战落地导向</h2>
              <h2 class="cdo-keyword-tag" style="background: rgba(255,255,255,0.15); color: white; border-color: rgba(255,255,255,0.3);">企业内训课程</h2>
              <h2 class="cdo-keyword-tag" style="background: rgba(255,255,255,0.15); color: white; border-color: rgba(255,255,255,0.3);">权威国标证书</h2>
              <h2 class="cdo-keyword-tag" style="background: rgba(255,255,255,0.15); color: white; border-color: rgba(255,255,255,0.3);">AI大语言模型培训</h2>
              <h2 class="cdo-keyword-tag" style="background: rgba(255,255,255,0.15); color: white; border-color: rgba(255,255,255,0.3);">人工智能 培训</h2>
            
            </div>
            <div style="display: flex; gap: 20px;">
              <a href="#enroll" class="btn-primary" style="background: white; color: #0E1F52; border: none;">立即报名 <i class="fas fa-arrow-right"></i></a>
              <a href="https://mp.weixin.qq.com/s/8xGhdeaxUTSgpRStT6cj6g?scene=1&click_id=1" target="_blank" rel="noopener noreferrer" class="btn-outline" style="border-color: white; color: white;">获取课程手册</a>
            </div>
          </div>
          <!-- 右侧抽象视觉 -->
          <div style="display: flex; justify-content: center;">
            <div style="width: 320px; height: 320px; background: rgba(255,255,255,0.08); border-radius: 50%; display: flex; align-items: center; justify-content: center; border: 2px solid rgba(255,255,255,0.2);">
              <i class="fas fa-user-tie" style="font-size: 120px; color: rgba(255,255,255,0.5);"></i>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- ===== 新增导航栏 ===== -->
    <section class="section">
      <div class="nav-bar">
        <a href="#background" class="nav-link">课程背景</a>
        <a href="#curriculum" class="nav-link">课程体系</a>
        <a href="#instructors" class="nav-link">核心导师</a>
        <a href="#faq" class="nav-link">常见问题</a>
        <a href="#enroll" class="nav-link cta">立即报名</a>
      </div>
    </section>

    <!-- ===== 02. 课程背景区 ===== -->
    <section class="section" id="background">
      <h2 class="container">课程背景</h2>
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 48px;">
        <div>
          <p style="font-size: 16px; line-height: 1.8;">大语言模型技术正以指数级速度重构企业智能升级路径。从ChatGPT到GPT-4，从开源模型到垂直领域微调，AI能力已成为企业核心竞争力。</p>
          <p>本课程联合工信部电子标准院，本课程联合一线AI专家与头部企业案例，系统化拆解大模型原理、提示工程、检索增强生成(RAG)、AI Agent开发，帮助团队真正掌握可落地的AI技能。帮助企业人员解决以下四类问题：</p>
          <div style="display: flex; gap: 30px; margin-top: 24px;">
            <div><i class="fas fa-database" style="color: #1F3F8F;"></i> <strong>不懂如何将AI融入现有业务</strong> 68%企业无财务决策分析能力</div>
            <div><i class="fas fa-sitemap" style="color: #1F3F8F;"></i> <strong>不会设计高效Prompt，输出质量低</strong> 财务数据分散、数据孤岛严重</div>
            <div><i class="fas fa-sitemap" style="color: #1F3F8F;"></i> <strong>无法构建基于私有知识的RAG问答系统</strong> 决策能力有限</div> 
            <div><i class="fas fa-sitemap" style="color: #1F3F8F;"></i> <strong>缺乏企业级AI应用架构与Agent开发能力</strong> 决策支持能力有限</div> 
          </div>
        </div>
        <div style="background: #EAF0FB; border-radius: 16px; padding: 30px; display: flex; align-items: center; justify-content: center;">
          <i class="fas fa-chart-pie" style="font-size: 100px; color: #1F3F8F; opacity: 0.5;"></i>
          <span style="margin-left: 20px; font-weight: 500;">AI应用管理成熟度评估</span>
        </div>
      </div>
    </section>

    <!-- 03. 课程目标区 (四列卡片) -->
    <section class="section bg-light">
      <h2 class="container">课程目标</h2>
      <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px;">
        <div class="card">
          <div class="cdo-card-icon" style="margin-bottom: 16px;"><i class="fas fa-chess-board"></i></div>
          <h3 class="cdo-h3">AI战略与体系</h3>
          <p>构建AI应用管理体系，规划战略，提升跨部门协同，AI专题实践。</p>
        </div>
        <div class="card">
          <div class="cdo-card-icon" style="margin-bottom: 16px;"><i class="fas fa-chart-line"></i></div>
          <h3 class="cdo-h3">AI运营与交易</h3>
          <p>AI平台、资产管理及运营实战，AI资产入表与估值。</p>
        </div>
        <div class="card">
          <div class="cdo-card-icon" style="margin-bottom: 16px;"><i class="fas fa-shield"></i></div>
          <h3 class="cdo-h3">AI合规与出境</h3>
          <p>AI合规、AI出境及AI 资产入表法律实务。</p>
        </div>
        <div class="card">
          <div class="cdo-card-icon" style="margin-bottom: 16px;"><i class="fas fa-robot"></i></div>
          <h3 class="cdo-h3">AI实践应用</h3>
          <p>大语言模型基础、智能体实践、AI与业务融合专题。</p>
        </div>
      </div>
    </section>

    <!-- 04. 课程受众群体区 -->
    <section class="section">
      <h2 class="container">适合人群</h2>
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 48px;">
        <div>
          <ul style="list-style: none; padding-left: 0;">
            <li style="padding: 10px 0;"><i class="fas fa-check-circle" style="color: #1F3F8F; margin-right: 12px;"></i>首席数据官（CDO）/CIO/CTO 及数科公司负责人</li>
            <li style="padding: 10px 0;"><i class="fas fa-check-circle" style="color: #1F3F8F; margin-right: 12px;"></i>公司中高层/数据部门负责人</li>
            <li style="padding: 10px 0;"><i class="fas fa-check-circle" style="color: #1F3F8F; margin-right: 12px;"></i>业务部门负责人/业务部门从事数据相关人员</li>
            <li style="padding: 10px 0;"><i class="fas fa-check-circle" style="color: #1F3F8F; margin-right: 12px;"></i>风控合规负责人、审计负责人</li>
            <li style="padding: 10px 0;"><i class="fas fa-check-circle" style="color: #1F3F8F; margin-right: 12px;"></i>财务数字化负责人</li>
          </ul>
        </div>
        <div style="background: #EAF0FB; border-radius: 16px; padding: 32px;">
          <p style="font-weight: 500;">课程定位为财务共享中心，要求学员从事财务领域相关工作，致力于成为企业财务数据价值的驱动者。每期限按照客户内训需求启动（常见：30人-150人），保证实践强化培训效果。</p>
        </div>
      </div>
    </section>

    <!-- 05. 权威认证与合作机构区 -->
    <section class="section bg-light">
      <h2 class="container">权威认证与联合机构</h2>
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 48px; align-items: center;">
        <div style="background: white; border-radius: 24px; padding: 40px; text-align: center; box-shadow: 0 12px 28px rgba(0, 10, 30, 0.04), 0 4px 12px rgba(0, 20, 40, 0.03);">
          <i class="fas fa-certificate" style="font-size: 80px; color: #1F3F8F;"></i>
          <h3 class="cdo-h3" style="margin: 20px 0 10px;">工信部电子标准院</h3>
          <p>联合项目认证 · 国标权威证书</p>
          <p style="font-size: 14px;">完成课程并通过考试，获得"财务数据分析师"证书，纳入工业和信息化人才数据库。</p>
        </div>
        <div>
          <p style="font-weight: 600;">证书说明：</p>
          <p>由工信部电子工业标准化研究院（或工信部教考中心）颁发《财务数据分析师》证书，可作为财务数据领域专业能力证明，助力企业财务数据资产评估、项目投标、个人职称晋升。证书唯一编号，官网可查。</p>
          <a href="#" class="internal-link" @click.prevent="showCertModal = true">查看证书样本 <i class="fas fa-arrow-right"></i></a>
        </div>
      </div>
    </section>

    <!-- 06. 课程体系结构区 (id=curriculum) -->
    <section class="section" id="curriculum">
      <h2 class="container">课程体系 · 四大模块</h2>
      <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px;">
        <div class="card bg-porcelain" style="border: none;">
          <h3 class="cdo-h3">模块一：财务数据战略与组织治理</h3>
          <ul style="list-style: none; padding-left: 0;">
            <li style="padding: 6px 0;"><i class="fas fa-caret-right" style="color: var(--cdo-accent-blue);"></i> CDO定位与数据文化</li>
            <li style="padding: 6px 0;"><i class="fas fa-caret-right" style="color: var(--cdo-accent-blue);"></i> 数据战略规划与执行</li>
            <li style="padding: 6px 0;"><i class="fas fa-caret-right" style="color: var(--cdo-accent-blue);"></i> 财务数据治理组织架构设计</li>
            <li style="padding: 6px 0;"><i class="fas fa-caret-right" style="color: var(--cdo-accent-blue);"></i> 财务数据制度与流程体系</li>
          </ul>
        </div>
        <div class="card bg-porcelain" style="border: none;">
          <h3 class="cdo-h3">模块二：财务数据治理体系建设</h3>
          <ul style="list-style: none; padding-left: 0;">
            <li style="padding: 6px 0;"><i class="fas fa-caret-right" style="color: var(--cdo-accent-blue);"></i> 财务数据标准/质量/主数据</li>
            <li style="padding: 6px 0;"><i class="fas fa-caret-right" style="color: var(--cdo-accent-blue);"></i> 财务数据架构与元数据</li>
            <li style="padding: 6px 0;"><i class="fas fa-caret-right" style="color: var(--cdo-accent-blue);"></i> 财务数据生命周期管理</li>
            <li style="padding: 6px 0;"><i class="fas fa-caret-right" style="color: var(--cdo-accent-blue);"></i> 财务数据治理成熟度评估</li>
          </ul>
        </div>
        <div class="card bg-porcelain" style="border: none;">
          <h3 class="cdo-h3">模块三：财务数据资产与价值实现</h3>
          <ul style="list-style: none; padding-left: 0;">
            <li style="padding: 6px 0;"><i class="fas fa-caret-right" style="color: var(--cdo-accent-blue);"></i> 财务数据资产盘点与确权</li>
            <li style="padding: 6px 0;"><i class="fas fa-caret-right" style="color: var(--cdo-accent-blue);"></i> 财务数据价值评估与入表</li>
            <li style="padding: 6px 0;"><i class="fas fa-caret-right" style="color: var(--cdo-accent-blue);"></i> 财务数据流通与交易实践</li>
            <li style="padding: 6px 0;"><i class="fas fa-caret-right" style="color: var(--cdo-accent-blue);"></i> 财务数据产品设计与运营</li>
          </ul>
        </div>
        <div class="card bg-porcelain" style="border: none;">
          <h3 class="cdo-h3">模块四：财务数据安全与合规管理</h3>
          <ul style="list-style: none; padding-left: 0;">
            <li style="padding: 6px 0;"><i class="fas fa-caret-right" style="color: var(--cdo-accent-blue);"></i> 数据分类分级与保护</li>
            <li style="padding: 6px 0;"><i class= "fas fa-caret-right" style="color: var(--cdo-accent-blue);"></i> 数据出境合规实务</li>
            <li style="padding: 6px 0;"><i class="fas fa-caret-right" style="color: var(--cdo-accent-blue);"></i> 隐私计算与合规技术</li>
            <li style="padding: 6px 0;"><i class="fas fa-caret-right" style="color: var(--cdo-accent-blue);"></i> AI伦理与监管</li>
          </ul>
        </div>
      </div>
    </section>

    <!-- 07. 课程计划与时间安排区 -->
    <section class="section bg-light">
      <h2 class="container">课程安排（3天实战研修）</h2>
      <table class="course-table">
        <thead>
          <tr><th>时间</th><th>课程主题</th><th>模块</th></tr>
        </thead>
        <tbody>
          <tr><td>Day1 09:00-17:00</td><td>财务数据战略顶层设计与组织变革</td><td>模块一</td></tr>
          <tr><td>Day2 09:00-17:00</td><td>财务数据治理落地与资产运营实战</td><td>模块二/三</td></tr>
          <tr><td>Day3 09:00-12:00</td><td>财务数据合规与AI实践专题</td><td>模块四</td></tr>
          <tr><td>Day3 14:00-16:30</td><td>结业考试与证书颁发</td><td>考核</td></tr>
        </tbody>
      </table>
      <div style="margin-top: 24px; display: flex; gap: 40px;">
        <span><i class="fas fa-calendar-alt" style="color: var(--cdo-accent-blue);"></i> 周期：3天线下集训+1个月线上辅导</span>
        <span><i class="fas fa-laptop" style="color: var(--cdo-accent-blue);"></i> 授课方式：北京/上海/深圳 混合学习</span>
      </div>
    </section>

    <!-- 08. 师资阵容区 (id=instructors) -->
    <section class="section" id="instructors">
      <h2 class="container">核心导师团队</h2>
      <div style="display: grid; grid-template-columns: repeat(4, 1fr); gap: 24px;">
        <div class="cdo-teacher-card">
          <div class="cdo-avatar"><i class="fas fa-user-tie"></i></div>
          <h4 class="cdo-h4">张华平</h4>
          <p class="cdo-teacher-title">工信部电子标准院 特聘专家</p>
          <p style="font-size: 14px;">原中国移动数据治理负责人，主导数据资产入表试点，服务30+央企。</p>
        </div>
        <div class="cdo-teacher-card">
          <div class="cdo-avatar"><i class="fas fa-user-graduate"></i></div>
          <h4 class="cdo-h4">李敏</h4>
          <p class="cdo-teacher-title">某国际咨询 数据合伙人</p>
          <p style="font-size: 14px;">前德勤数据治理总监，DAMA 认证专家，著有《数据战略落地》。</p>
        </div>
        <div class="cdo-teacher-card">
          <div class="cdo-avatar"><i class="fas fa-user-astronaut"></i></div>
          <h4 class="cdo-h4">陈曦</h4>
          <p class="cdo-teacher-title">阿里云 数据产品专家</p>
          <p style="font-size: 14px;">数据中台建设、数据资产运营，10年大数据实战经验。</p>
        </div>
        <div class="cdo-teacher-card">
          <div class="cdo-avatar"><i class="fas fa-user-lock"></i></div>
          <h4 class="cdo-h4">王瑾</h4>
          <p class="cdo-teacher-title">环球律所 数据合规合伙人</p>
          <p style="font-size: 14px;">GDPR/数据出境/上市数据合规，辅导超过50家头部企业。</p>
        </div>
      </div>
    </section>

    <!-- 09. 往期回顾与学员反馈区 -->
    <section class="section bg-light">
      <h2 class="container">往期回顾 · 学员反馈</h2>
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 48px;">
        <div>
          <div style="border-radius: 16px; overflow: hidden; height: 200px; margin-bottom: 20px;">
            <img src="@/assets/img/cdo-training-site.jpg" alt="首席数据官培训现场" style="width: 100%; height: 100%; object-fit: cover; display: block;">
          </div>
          <p><i class="fas fa-users" style="color: var(--cdo-accent-blue);"></i> 累计培训财务共享中心人员（执行侧、高管）1200+ 人 · 服务企业包括国家电网、中石化、华为、招商银行等</p>
          <a href="#" class="internal-link" @click.prevent="showCoverageModal = true">往期报道 <i class="fas fa-arrow-right"></i></a>
        </div>
        <div class="testimonial-carousel">
          <div class="testimonial-card">
            <i class="fas fa-quote-left testimonial-quote-icon"></i>
            <p class="testimonial-text">{{ testimonials[currentTestimonial].text }}</p>
            <p class="testimonial-author">{{ testimonials[currentTestimonial].author }}</p>
            <hr style="margin: 20px 0; border-color: #eee;">
            <div style="display: flex; gap: 30px; align-items: center;">
              <span><strong>{{ testimonials[currentTestimonial].recommend }}</strong> 学员推荐</span>
              <span><strong>{{ testimonials[currentTestimonial].rating }}</strong> 课程满意度</span>
            </div>
          </div>
          <div class="testimonial-nav">
            <button class="testimonial-dot" v-for="(t, i) in testimonials" :key="i" :class="{ active: i === currentTestimonial }" @click="goToTestimonial(i)"></button>
          </div>
          <div class="testimonial-arrows">
            <button class="testimonial-arrow" @click="prevTestimonial"><i class="fas fa-chevron-left"></i></button>
            <button class="testimonial-arrow" @click="nextTestimonial"><i class="fas fa-chevron-right"></i></button>
          </div>
        </div>
      </div>
    </section>

    <!-- 10. FAQ模块 (id=faq) -->
    <section class="section" id="faq">
      <h2 class="container">常见问题</h2>
      <div class="cdo-faq">
        <div class="cdo-faq-item">
          <h4 class="cdo-h4"><i class="fas fa-question-circle" style="color: var(--cdo-accent-blue);"></i> 课程适合什么级别的管理者？</h4>
          <p>主要面向企业数据、信息化、业务及合规部门的总监及以上负责人，建议拥有5年以上管理经验。</p>
        </div>
        <div class="cdo-faq-item">
          <h4 class="cdo-h4"><i class="fas fa-question-circle" style="color: var(--cdo-accent-blue);"></i> 可以获得什么证书？</h4>
          <p>通过考试后，由工信部电子标准院颁发《财务数据分析师》证书，权威可查。</p>
        </div>
        <div class="cdo-faq-item">
          <h4 class="cdo-h4"><i class="fas fa-question-circle" style="color: var(--cdo-accent-blue);"></i> 课程费用包含食宿吗？</h4>
          <p>费用包含培训、教材、认证费，食宿自理，可协助预定酒店。企业团报有优惠。</p>
        </div>
      </div>
      <div style="margin-top: 24px;">
        <a href="#" class="internal-link" @click.prevent="downloadBrochure">查看完整课程大纲 <i class="fas fa-download"></i></a>
      </div>
    </section>

    <!-- 11 底部转化模块 -->
    <section id="contact" class="section" style="margin-bottom: 50px;">
      <h2 style="text-align: center;"><i class="fa-regular fa-star"></i> 预约咨询 </h2>  
      <!-- early-bird-container: 早鸟容器，包括左侧 early-bird-left、右侧 early-bird-right -->
       <div class="p-10 rounded-2xl border border-divider shadow-sm" style="padding-top: 4rem; padding-bottom: 4rem;">
          <!-- Section-Title -->
          <div class="early-bird-container">
              <!-- 左侧文案 -->
              <div class="early-bird-left">
                <h2 class="early-bird-title">
                  {{ courseName }}
                </h2>
                <div class="early-bird-info">
                  <p>
                    <i class="fas fa-calendar-alt"></i>
                    <span>开课时间：{{ startDate }}</span>
                  </p>
                  <p>
                    <i class="fas fa-users"></i>
                    <span>名额限制：仅剩 <span class="highlight">{{ spotsLeft }}</span> 席 / 每班{{ classSize }}人</span>
                  </p>
                  <p>
                    <i class="fas fa-gift"></i>
                    <span>早鸟优惠截止 <span class="highlight">{{ earlyBirdDeadline }}</span></span>
                  </p>
                </div>
              </div>

              <!-- 右侧双二维码 -->
              <div class="early-bird-right">
                <div
                  v-for="(advisor, index) in advisors"
                  :key="index"
                  class="advisor-card"
                >
                  <div class="advisor-qr">
                    <img :src="advisor.qrCode" alt="顾问二维码" style="width: 100%; height: auto; border-radius: 8px;">
                  </div>
                  <div class="advisor-name">{{ advisor.name }}</div>
                  <div class="advisor-title">{{ advisor.title }}</div>
                  <div class="advisor-hint">{{ advisor.hint }}</div>
                </div>
              </div>
          </div>
      </div>
    </section>


    <!-- 证书样本弹窗 -->
    <div v-if="showCertModal" class="coverage-modal-overlay" @click.self="showCertModal = false">
      <div class="cert-modal">
        <div class="coverage-modal-header">
          <h3><i class="fas fa-certificate" style="color: var(--cdo-accent-blue); margin-right: 10px;"></i>证书样本 · 工信部电子标准院</h3>
          <button class="coverage-modal-close" @click="showCertModal = false"><i class="fas fa-times"></i></button>
        </div>
        <div class="cert-modal-body">
          <div class="cert-side">
            <div class="cert-side-label">正面</div>
            <img src="@/assets/img/cdo/cdo-zm-dianbiaoyuan.jpg" alt="证书正面" class="cert-img">
          </div>
          <div class="cert-side">
            <div class="cert-side-label">背面</div>
            <img src="@/assets/img/cdo/cdo-bm-dianbiaoyuan.jpg" alt="证书背面" class="cert-img">
          </div>
        </div>
        <div class="cert-modal-note">
          <i class="fas fa-info-circle" style="margin-right: 6px;"></i>
          通过人才岗位认证的考生提供电子证书下载和查询（电标院首席数据官查询网址：<a href="https://www.cesi.cn/page/pxzscx.html" target="_blank" rel="noopener noreferrer">https://www.cesi.cn/page/pxzscx.html</a>）
        </div>
      </div>
    </div>

    <!-- 往期报道弹窗 -->
    <div v-if="showCoverageModal" class="coverage-modal-overlay" @click.self="showCoverageModal = false">
      <div class="coverage-modal">
        <div class="coverage-modal-header">
          <h3><i class="fas fa-newspaper" style="color: var(--cdo-accent-blue); margin-right: 10px;"></i>往期首席数据官培训报道 · 2025</h3>
          <button class="coverage-modal-close" @click="showCoverageModal = false"><i class="fas fa-times"></i></button>
        </div>
        <div class="coverage-modal-body">
          <a href="https://baijiahao.baidu.com/s?id=1855460944540939594&wfr=spider&for=pc" target="_blank" rel="noopener noreferrer" class="coverage-item">
            <div class="coverage-item-label">五期（公开课）</div>
            <div class="coverage-item-title">首席数据官实践班第五期 · 公开课报道</div>
            <i class="fas fa-external-link-alt"></i>
          </a>
          <a href="https://mp.weixin.qq.com/s/wXAQ3-1K32z3AMiobXsGkw?scene=1&click_id=2" target="_blank" rel="noopener noreferrer" class="coverage-item">
            <div class="coverage-item-label">四期</div>
            <div class="coverage-item-title">首席数据官实践班第四期 · 培训纪实</div>
            <i class="fas fa-external-link-alt"></i>
          </a>
          <a href="https://mp.weixin.qq.com/s/DuPHNWYaC0H2bSwRZf_BYw?scene=1&click_id=3" target="_blank" rel="noopener noreferrer" class="coverage-item">
            <div class="coverage-item-label">二期</div>
            <div class="coverage-item-title">首席数据官实践班第二期 · 培训纪实</div>
            <i class="fas fa-external-link-alt"></i>
          </a>
          <a href="https://mp.weixin.qq.com/s/GTWCzEa_HOi5GfZJw4146Q?scene=1&click_id=4" target="_blank" rel="noopener noreferrer" class="coverage-item">
            <div class="coverage-item-label">一期</div>
            <div class="coverage-item-title">首席数据官实践班第一期 · 培训纪实</div>
            <i class="fas fa-external-link-alt"></i>
          </a>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'EarlyBirdSection',
  data() {
    return {
      showCoverageModal: false,
      showCertModal: false,
      currentTestimonial: 0,
      testimonialTimer: null,
      testimonials: [
        {
          text: '"课程体系非常系统，从财务战略到资产运营，尤其是财务数据入表和AI结合部分，对我们集团数据部建设很有启发。"',
          author: '—— 赵总  某大型央企财务数据中心负责人',
          recommend: '97%',
          rating: '4.8/5.0'
        },
        {
          text: '"完善的数据管理体系、充足的AI实践，学习完课程后，完成了第一次职业转变，参与了第一个数据治理咨询项目，收获颇多。后续，又在线上重复看了课程视频，更有感触。2026年，课程升级为：国标课程、重视实践，新增了AI大语言模型值得推荐"',
          author: '—— Nina  某头部农信社数字化业务负责',
          recommend: '99%',
          rating: '4.9/5.0'
        }
      ]
    }
  },
  mounted() {
    this.startCarousel()
  },
  beforeUnmount() {
    clearInterval(this.testimonialTimer)
  },
  methods: {
    startCarousel() {
      this.testimonialTimer = setInterval(() => {
        this.currentTestimonial = (this.currentTestimonial + 1) % this.testimonials.length
      }, 5000)
    },
    nextTestimonial() {
      clearInterval(this.testimonialTimer)
      this.currentTestimonial = (this.currentTestimonial + 1) % this.testimonials.length
      this.startCarousel()
    },
    prevTestimonial() {
      clearInterval(this.testimonialTimer)
      this.currentTestimonial = (this.currentTestimonial - 1 + this.testimonials.length) % this.testimonials.length
      this.startCarousel()
    },
    goToTestimonial(i) {
      clearInterval(this.testimonialTimer)
      this.currentTestimonial = i
      this.startCarousel()
    }
  },
  props: {
    // 课程名称，支持自定义
    courseName: {
      type: String,
      default: '报名本期 AI 大语言模型应用实战 培训课程'
    },
    startDate: {
      type: String,
      default: '2025年6月20日（北京）'
    },
    spotsLeft: {
      type: [String, Number],
      default: 10
    },
    classSize: {
      type: [String, Number],
      default: 35
    },
    earlyBirdDeadline: {
      type: String,
      default: '3月31日'
    },
    // 顾问信息数组
    advisors: {
      type: Array,
      default: () => [
        {
          name: '顾老师',
          title: '首席咨询顾问',
          hint: '扫码咨询 · 抢占名额',
          qrCode: require('@/assets/img/qr_gu.jpg')
        },
        {
          name: '桑老师',
          title: '课程规划专家',
          hint: '扫码咨询 · 获取大纲',
          qrCode: require('@/assets/img/qr_sang.jpg')
        }
      ]
    }
  }
}
</script>

<style scoped>
/* ---------- 全局重置与变量 ---------- */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html {
  scroll-behavior: smooth;
}

.cdo-page {
  font-family: 'Inter', 'Noto Serif SC', system-ui, -apple-system, sans-serif;
  background-color: #ffffff;
  color: #2B2F3A;
  line-height: 1.6;
}

/* 主蓝 #1F3F8F / 深靛蓝 #0E1F52 / 淡瓷蓝 #EAF0FB / 墨蓝灰 #2B2F3A */
:root {
  --primary-blue: #1F3F8F;
  --deep-indigo: #0E1F52;
  --light-porcelain: #EAF0FB;
  --text-dark: #2B2F3A;
  --accent-blue: #1F3F8F;
  --border-light: #e9edf4;
  --bg-light: #f5f7fa;
  --card-shadow: 0 12px 28px rgba(0, 10, 30, 0.04), 0 4px 12px rgba(0, 20, 40, 0.03);
  --cdo-primary-dark: #0E1F52;
  --cdo-accent-blue: #1F3F8F;
  --cdo-text-dark: #2B2F3A;
  --cdo-text-gray: #64748b;
  --cdo-bg-light: #f5f7fa;
  --cdo-border-light: #e9edf4;
}

/* 面包屑导航 */
.breadcrumb-nav {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 24px 10px;
  font-size: 14px;
  color: var(--cdo-text-gray);
}

.breadcrumb-nav a {
  color: var(--cdo-accent-blue);
  text-decoration: none;
  transition: color 0.2s;
}

.breadcrumb-nav a:hover {
  color: #0E1F52;
}

.breadcrumb-nav .separator {
  margin: 0 8px;
  color: #cbd5e1;
}

.breadcrumb-nav .current {
  color: var(--cdo-text-dark);
  font-weight: 500;
}

/* 容器 */
.section {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 16px;
}

.section:last-child {
  margin-bottom: 0;
}

/* 背景辅助类 */
.bg-light {
  background-color: var(--bg-light);
  padding: 60px 0;
}

.bg-porcelain {
  background-color: #EAF0FB;
}

/* 标题样式 */
h1, .cdo-h1 {
  font-size: 42px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: -0.02em;
  color: var(--deep-indigo);
  margin-bottom: 24px;
}

h2 {
    font-size: 28px;
    font-weight: 700;
    color: #0E1F52;
    margin-top: 20px;
    margin-bottom: 20px;
    letter-spacing: -0.01em;
    position: relative;
    display: inline-block;
}

h2:after {
    content: "";
    position: absolute;
    bottom: -10px;
    left: 0;
    width: 60px;
    height: 3px;
    background-color: #1F3F8F;
    border-radius: 4px;
}


h3, .cdo-h3 {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 12px;
  color: var(--deep-indigo);
}

h4, .cdo-h4 {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
  color: var(--text-dark);
}

p, li {
  font-size: 16px;
  color: var(--text-dark);
  margin-bottom: 16px;
}

.cdo-subhead {
  font-size: 18px;
  color: var(--cdo-text-gray);
  line-height: 1.7;
  margin-bottom: 20px;
}

/* 徽章 */
.cdo-badge {
  display: inline-block;
  background: var(--accent-blue);
  color: white;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 500;
  margin-right: 10px;
}

.cdo-badge.secondary {
  background: #10b981;
}

/* 按钮风格 */
.cdo-btn, .btn-primary, .btn-outline {
  display: inline-block;
  padding: 14px 36px;
  border-radius: 40px;
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s ease;
  border: 1px solid transparent;
  cursor: pointer;
  letter-spacing: 0.5px;
}

.cdo-btn-primary, .btn-primary {
  background-color: #0E1F52;
  color: white;
  border-color: #0E1F52;
  box-shadow: 0 6px 14px rgba(31,63,143,0.2);
}

.cdo-btn-primary:hover, .btn-primary:hover {
  background-color: #0E1F52;
  border-color: #0E1F52;
  box-shadow: 0 12px 22px rgba(31,63,143,0.3);
  transform: translateY(-2px);
}

.cdo-btn-outline, .btn-outline {
  background: transparent;
  color: #0E1F52;
  border-color: #0E1F52;
}

.cdo-btn-outline:hover, .btn-outline:hover {
  background-color: rgba(31,63,143,0.04);
  border-color: #0E1F52;
  color: #0E1F52;
}

.cdo-btn-white {
  background: white;
  color: #0E1F52;
  border-color: white;
}

.cdo-btn-white:hover {
  background: rgba(255,255,255,0.9);
  transform: translateY(-2px);
}

.cdo-btn-outline-white {
  background: transparent;
  color: white;
  border-color: white;
}

.cdo-btn-outline-white:hover {
  background: rgba(255, 255, 255, 0.1);
}

/* 信息卡片网格 */
.cdo-info-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 20px;
  margin: 40px 0;
}

.cdo-info-card {
  display: flex;
  align-items: center;
  gap: 16px;
  background: white;
  border: 1px solid rgba(31,63,143,0.05);
  border-radius: 12px;
  padding: 20px;
  transition: all 0.3s ease;
}

.cdo-info-card:hover {
  border-color: var(--accent-blue);
  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.1);
  transform: translateY(-2px);
}

.cdo-info-icon, .icon-circle-sm {
  width: 48px;
  height: 48px;
  background: #EAF0FB;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0E1F52;
  font-size: 20px;
  flex-shrink: 0;
}

.cdo-info-card h4 {
  font-size: 14px;
  color: var(--cdo-text-gray);
  margin-bottom: 4px;
  font-weight: 500;
}

.cdo-info-card p {
  font-size: 16px;
  color: var(--text-dark);
  font-weight: 600;
  margin: 0;
}

/* 标签组与关键词云 */
.tag-group, .cdo-keyword-cloud {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  margin: 20px 0 28px;
}

.tag, .cdo-keyword-tag {
  display: inline-block;
  background: rgba(31,63,143,0.05);
  color: #0E1F52;
  padding: 8px 20px;
  border-radius: 40px;
  font-size: 14px;
  font-weight: 500;
  border: 1px solid rgba(31,63,143,0.2);
  transition: all 0.2s;
}

.cdo-keyword-tag:hover {
  background: var(--accent-blue);
  color: white;
  transform: translateY(-2px);
}

.cdo-keyword-tag.highlight {
  background: var(--accent-blue);
  color: white;
  border-color: var(--accent-blue);
}

/* 网格系统 */
.grid-2, .cdo-card-grid-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 48px;
}

.grid-3, .cdo-card-grid-3 {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
}

.grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 24px;
}

.grid-5 {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
}


/* 卡片通用 */
.card {
    background: white;
    border-radius: 16px;
    padding: 28px 24px;
    box-shadow: 0 12px 30px rgba(0, 40, 40, 0.06);
    transition: transform 0.2s;
    border: 1px solid rgba(31,63,143,0.05);
}
.card:hover {
    transform: translateY(-3px);
    box-shadow: 0 20px 30px rgba(31,63,143,0.08);
}


.cdo-card-icon {
  width: 48px;
  height: 48px;
  background: #EAF0FB;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #1F3F8F;
  font-size: 20px;
  margin-bottom: 16px;
}

/* 收益列表 */
.cdo-benefit-item {
  display: flex;
  gap: 24px;
  align-items: flex-start;
  margin-bottom: 30px;
  padding: 24px;
  background: white;
  border-radius: 12px;
  border: 1px solid var(--cdo-border-light);
  transition: all 0.3s ease;
}

.cdo-benefit-item:hover {
  border-color: var(--cdo-accent-blue);
  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.1);
}

.cdo-benefit-number {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #1F3F8F 0%, #0E1F52 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 20px;
  font-weight: 700;
  flex-shrink: 0;
}

/* 课程大纲 */
.cdo-curriculum {
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.cdo-day-card {
  background: white;
  border: 2px solid var(--cdo-border-light);
  border-radius: 16px;
  padding: 30px;
  transition: all 0.3s ease;
}

.cdo-day-card:hover {
  border-color: var(--cdo-accent-blue);
  box-shadow: 0 8px 24px rgba(26, 115, 232, 0.1);
}

.cdo-day-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
}

.cdo-day-badge {
  background: linear-gradient(135deg, #1F3F8F 0%, #0E1F52 100%);
  color: white;
  padding: 8px 20px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
}

.cdo-curriculum-list {
  list-style: none;
  padding: 0;
}

.cdo-curriculum-list li {
  padding: 10px 0;
  color: var(--cdo-text-dark);
  font-size: 16px;
  border-bottom: 1px solid #f1f5f9;
}

.cdo-curriculum-list li:last-child {
  border-bottom: none;
}

.cdo-curriculum-list li i {
  color: var(--cdo-accent-blue);
  margin-right: 10px;
}

/* 讲师卡片 */
.cdo-teacher-card {
  background: white;
  border: 1px solid rgba(31,63,143,0.05);
  border-radius: 16px;
  padding: 30px;
  text-align: center;
  transition: all 0.3s ease;
}

.cdo-teacher-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transform: translateY(-4px);
  border-color: var(--accent-blue);
}

.cdo-avatar, .avatar-circle {
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: linear-gradient(145deg, #d6e0f0, #b0c2da);
  display: flex;
  align-items: center;
  justify-content: center;
  color: #0E1F52;
  font-size: 40px;
  margin: 0 auto 16px;
  border: 3px solid white;
  box-shadow: 0 6px 16px rgba(0,0,0,0.1);
}

.cdo-teacher-title {
  color: var(--accent-blue);
  font-size: 14px;
  margin-bottom: 16px;
  font-weight: 500;
}

.cdo-teacher-info {
  list-style: none;
  padding: 0;
  text-align: left;
}

.cdo-teacher-info li {
  padding: 6px 0;
  color: var(--cdo-text-gray);
  font-size: 14px;
}

/* 案例卡片 */
.cdo-case-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
  gap: 24px;
  margin-bottom: 40px;
}

.cdo-case-card {
  background: white;
  border: 1px solid var(--cdo-border-light);
  border-radius: 16px;
  padding: 30px;
  transition: all 0.3s ease;
}

.cdo-case-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.08);
  transform: translateY(-4px);
}

.cdo-case-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.cdo-industry-tag {
  background: var(--cdo-accent-blue);
  color: white;
  padding: 4px 12px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 600;
}

.cdo-case-card p {
  margin-bottom: 12px;
  color: var(--cdo-text-gray);
  font-size: 15px;
  line-height: 1.6;
}

/* Logo墙 */
.cdo-logo-wall {
  margin-top: 40px;
  padding: 30px;
  background: var(--cdo-bg-light);
  border-radius: 12px;
}

.cdo-logo-grid {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 20px;
}

.cdo-logo-item {
  padding: 12px 24px;
  background: white;
  border-radius: 8px;
  font-weight: 600;
  color: var(--cdo-text-dark);
  font-size: 14px;
  border: 1px solid var(--cdo-border-light);
}

/* 证书卡片 */
.cdo-cert-card {
  display: flex;
  gap: 30px;
  align-items: flex-start;
  background: white;
  border: 2px solid var(--cdo-accent-blue);
  border-radius: 16px;
  padding: 40px;
}

.cdo-cert-icon {
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #1F3F8F 0%, #0E1F52 100%);
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 40px;
  flex-shrink: 0;
}

.cdo-cert-info {
  list-style: none;
  padding: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
}

.cdo-cert-info li {
  color: var(--cdo-text-gray);
  font-size: 15px;
}

.cdo-cert-info li i {
  color: var(--cdo-accent-blue);
  margin-right: 8px;
}

/* 培训模式卡片 */
.cdo-mode-card {
  background: white;
  border: 2px solid var(--cdo-border-light);
  border-radius: 16px;
  padding: 40px;
  transition: all 0.3s ease;
}

.cdo-mode-card:hover {
  border-color: var(--cdo-accent-blue);
  box-shadow: 0 8px 24px rgba(26, 115, 232, 0.1);
}

.cdo-mode-list {
  list-style: none;
  padding: 0;
  margin-top: 20px;
}

.cdo-mode-list li {
  padding: 12px 0;
  color: var(--cdo-text-gray);
  font-size: 15px;
  border-bottom: 1px solid #f1f5f9;
}

.cdo-mode-list li:last-child {
  border-bottom: none;
}



/* 三列网格布局 */
.cdo-benefit-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 30px;
  max-width: 1200px;
  margin: 0 auto;
}





/* 报名流程 */
.cdo-process {
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 1000px;
  margin: 0 auto;
  flex-wrap: wrap;
  gap: 20px;
}

.cdo-process-step {
  text-align: center;
  flex: 1;
  min-width: 140px;
}

.cdo-process-number {
  width: 60px;
  height: 60px;
  background: linear-gradient(135deg, #1F3F8F 0%, #0E1F52 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  font-weight: 700;
  margin: 0 auto 16px;
}

.cdo-process-arrow {
  color: var(--cdo-accent-blue);
  font-size: 24px;
  flex-shrink: 0;
}

.cdo-process-step p {
  font-size: 14px;
  color: var(--cdo-text-gray);
  margin: 0;
}

/* FAQ */
.cdo-faq {
  max-width: 900px;
  margin: 0 auto;
}

.cdo-faq-item {
  background: white;
  border: 1px solid var(--cdo-border-light);
  border-radius: 12px;
  padding: 12px;
  margin-bottom: 6px;
  transition: all 0.3s ease;
}

.cdo-faq-item:hover {
  border-color: var(--cdo-accent-blue);
  box-shadow: 0 4px 12px rgba(26, 115, 232, 0.1);
}

.cdo-faq-item h4 {
  color: var(--cdo-text-dark);
  margin-bottom: 12px;
}

.cdo-faq-item p {
  color: var(--cdo-text-gray);
  line-height: 1.7;
  margin: 0;
}

/* CTA区 */
.cdo-cta {
  background: linear-gradient(135deg, #1F3F8F 0%, #0E1F52 100%);
  padding: 15px 10px;
  margin-top: 5px;
}

.cdo-cta-content {
  text-align: center;
}

/* Hero特殊渐变 */
.hero-gradient {
  background: linear-gradient(135deg, #1F3F8F 0%, #0E1F52 100%);
  color: white;
}

/* 导航栏样式 */
.nav-bar {
  background: white;
  border-radius: 60px;
  box-shadow: 0 8px 24px rgba(31,63,143,0.08);
  padding: 12px 28px;
  margin: 30px 0 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  border: 1px solid rgba(31,63,143,0.1);
}

.nav-link {
  font-size: 16px;
  font-weight: 500;
  color: var(--deep-indigo);
  text-decoration: none;
  padding: 6px 0;
  border-bottom: 2px solid transparent;
  transition: border-color 0.2s, color 0.2s;
}

.nav-link:hover {
  color: #0E1F52;
  border-bottom-color: #0E1F52;
}

.nav-link.cta {
  background-color: #0E1F52;
  color: white;
  padding: 10px 28px;
  border-radius: 40px;
  border-bottom: none;
  box-shadow: 0 4px 10px rgba(31,63,143,0.2);
}

.nav-link.cta:hover {
  background-color: #1F3F8F;
  color: white;
}

/* 内部链接样式 */
.internal-link {
  color: #0E1F52;
  text-decoration: none;
  font-weight: 500;
  border-bottom: 1px dashed currentColor;
}

.internal-link:hover {
  border-bottom-style: solid;
}

/* 往期报道弹窗 */
.coverage-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(14, 31, 82, 0.55);
  backdrop-filter: blur(3px);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
}

.coverage-modal {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 24px 60px rgba(0, 10, 50, 0.18);
  width: 100%;
  max-width: 560px;
  overflow: hidden;
}

.coverage-modal-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 28px 20px;
  border-bottom: 1px solid #e9edf4;
}

.coverage-modal-header h3 {
  font-size: 18px;
  font-weight: 700;
  color: #0E1F52;
  margin: 0;
}

.coverage-modal-close {
  background: none;
  border: none;
  cursor: pointer;
  color: #94a3b8;
  font-size: 18px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s, color 0.2s;
}

.coverage-modal-close:hover {
  background: #f1f5f9;
  color: #0E1F52;
}

.coverage-modal-body {
  padding: 16px 20px 24px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.coverage-item {
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 18px;
  border-radius: 12px;
  border: 1px solid #e9edf4;
  text-decoration: none;
  color: #2B2F3A;
  transition: background 0.2s, border-color 0.2s, box-shadow 0.2s;
}

.coverage-item:hover {
  background: #EAF0FB;
  border-color: #1F3F8F;
  box-shadow: 0 4px 12px rgba(31, 63, 143, 0.1);
}

.coverage-item-label {
  flex-shrink: 0;
  background: #1F3F8F;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
  padding: 4px 10px;
  border-radius: 20px;
  min-width: 52px;
  text-align: center;
}

.coverage-item-title {
  flex: 1;
  font-size: 15px;
  font-weight: 500;
}

.coverage-item .fa-external-link-alt {
  color: #94a3b8;
  font-size: 13px;
  flex-shrink: 0;
}

/* 证书弹窗 */
.cert-modal {
  background: #fff;
  border-radius: 20px;
  box-shadow: 0 24px 60px rgba(0, 10, 50, 0.18);
  width: 100%;
  max-width: 760px;
  overflow: hidden;
}

.cert-modal-body {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  padding: 20px 24px 28px;
}

.cert-side {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.cert-side-label {
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  letter-spacing: 0.05em;
}

.cert-img {
  width: 100%;
  border-radius: 10px;
  box-shadow: 0 6px 24px rgba(0, 10, 50, 0.12);
  display: block;
}

.cert-modal-note {
  margin: 0 24px 20px;
  padding: 12px 16px;
  background: #f0f5ff;
  border-left: 3px solid #1F3F8F;
  border-radius: 6px;
  font-size: 13px;
  color: #4a5568;
  line-height: 1.6;
}

.cert-modal-note a {
  color: #1F3F8F;
  word-break: break-all;
}

.cert-modal-note a:hover {
  text-decoration: underline;
}

/* 学员反馈轮播 */
.testimonial-carousel {
  background: white;
  border-radius: 16px;
  padding: 30px;
  box-shadow: 0 12px 28px rgba(0, 10, 30, 0.04), 0 4px 12px rgba(0, 20, 40, 0.03);
  position: relative;
  display: flex;
  flex-direction: column;
}

.testimonial-card {
  flex: 1;
}

.testimonial-quote-icon {
  color: var(--cdo-bg-light);
  font-size: 32px;
}

.testimonial-text {
  font-style: italic;
  margin: 12px 0 10px;
  line-height: 1.8;
  min-height: 80px;
}

.testimonial-author {
  font-weight: 600;
}

.testimonial-nav {
  display: flex;
  justify-content: center;
  gap: 8px;
  margin-top: 20px;
}

.testimonial-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  border: none;
  background: #cbd5e1;
  cursor: pointer;
  padding: 0;
  transition: background 0.3s, transform 0.3s;
}

.testimonial-dot.active {
  background: #1F3F8F;
  transform: scale(1.3);
}

.testimonial-arrows {
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  display: flex;
  justify-content: space-between;
  pointer-events: none;
  padding: 0 6px;
}

.testimonial-arrow {
  pointer-events: all;
  background: #f1f5f9;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  cursor: pointer;
  color: #1F3F8F;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  font-size: 13px;
}

.testimonial-arrow:hover {
  background: #EAF0FB;
}

/* 表格样式 */
.course-table {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: var(--card-shadow);
}

.course-table th {
  background-color: #0E1F52;
  color: white;
  font-weight: 600;
  padding: 16px 20px;
  text-align: left;
}

.course-table td {
  padding: 16px 20px;
  border-bottom: 1px solid var(--border-light);
}

.course-table tr:last-child td {
  border-bottom: none;
}

/* 背景色块 */
.bg-porcelain {
  background-color: #EAF0FB;
}

/* 响应式 */
@media (max-width: 768px) {
  .cdo-h1 {
    font-size: 32px;
  }
  
  
  .cdo-case-grid {
    grid-template-columns: 1fr;
  }
  
  .cdo-info-grid {
    grid-template-columns: 1fr;
  }
  
  .cdo-process {
    flex-direction: column;
  }
  
  .cdo-process-arrow {
    transform: rotate(90deg);
  }
  
  .cdo-cert-card {
    flex-direction: column;
  }
  
  .cdo-cert-info {
    grid-template-columns: 1fr;
  }
  
  .nav-bar {
    flex-direction: column;
    gap: 20px;
  }
}



/* 早鸟报名区域样式 - 青花瓷色系优化版 */
.early-bird-section {
  background-color: #e9edf4; /* 深靛蓝背景 */
  padding: 60px 0;
  margin: 60px 0;
  color: #ffffff;
  font-family: 'Inter', system-ui, -apple-system, sans-serif;
}

.early-bird-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 40px;
}

/* 左侧文案区域 */
.early-bird-left {
  flex: 1 1 450px;
}

.early-bird-title {
  font-size: 32px;
  font-weight: 700;
  line-height: 1.3;
  margin-bottom: 24px;
  color: #0E1F52;
  letter-spacing: 0.5px;
  position: relative;
  padding-bottom: 16px;
}

.early-bird-title::after {
  content: '';
  position: absolute;
  left: 0;
  bottom: 0;
  width: 60px;
  height: 3px;
  background-color: #1F3F8F; /* 主蓝 */
  border-radius: 2px;
}

.early-bird-info p {
  font-size: 18px;
  margin-bottom: 16px;
  display: flex;
  align-items: center;
  gap: 12px;
  color: #0E1F52;
  font-weight: 400;
}

.early-bird-info i {
  width: 24px;
  color: #1F3F8F; /* 主蓝 */
  font-size: 20px;
}

.early-bird-info .highlight {
  font-weight: 700;
  color: #2A5CAA; /* 稍亮的蓝色，更醒目 */
  background: rgba(255, 255, 255, 0.15);
  padding: 2px 10px;
  border-radius: 30px;
  margin-left: 4px;
  display: inline-block;
}

/* 右侧二维码区域 */
.early-bird-right {
  flex: 1 1 400px;
  display: flex;
  justify-content: center;
  gap: 30px;
  flex-wrap: wrap;
}

.advisor-card {
  background: #ffffff;
  border-radius: 24px;
  padding: 28px 20px 20px;
  text-align: center;
  box-shadow: 0 20px 35px rgba(0, 0, 0, 0.25);
  flex: 0 1 200px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid rgba(31, 63, 143, 0.1);
}

.advisor-card:hover {
  transform: translateY(-6px);
  box-shadow: 0 25px 40px rgba(0, 0, 0, 0.3);
}

.advisor-qr {
  width: 120px;
  height: 120px;
  background: #EAF0FB; /* 淡瓷蓝 */
  border-radius: 20px;
  margin: 0 auto 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid #1F3F8F;
  transition: border-color 0.2s;
}

.advisor-card:hover .advisor-qr {
  border-color: #2A5CAA;
}

.advisor-qr i {
  font-size: 60px;
  color: #1F3F8F;
  opacity: 0.85;
}

.advisor-name {
  font-weight: 700;
  font-size: 20px;
  color: #0E1F52; /* 深靛蓝 */
  margin-bottom: 4px;
}

.advisor-title {
  font-size: 14px;
  color: #5f6a7d;
  margin-bottom: 16px;
  font-weight: 400;
}

.advisor-hint {
  font-size: 14px;
  font-weight: 600;
  color: #1F3F8F;
  border-top: 1px dashed #d0d9e8;
  padding-top: 14px;
  margin-top: 6px;
  letter-spacing: 0.3px;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .early-bird-container {
    flex-direction: column;
    text-align: center;
  }

  .early-bird-title::after {
    left: 50%;
    transform: translateX(-50%);
  }

  .early-bird-info p {
    justify-content: center;
  }

  .early-bird-right {
    gap: 20px;
  }

  .advisor-card {
    flex: 0 1 180px;
  }
}

@media (max-width: 480px) {
  .early-bird-title {
    font-size: 28px;
  }

  .early-bird-info p {
    font-size: 16px;
    flex-wrap: wrap;
  }
}


</style>
